module.exports = __webpack_public_path__ + "img/GitLab.be52b46.svg";